export const LEGAL_NAME_LABELS = {
  firstName: 'Legal first name',
  middleName: 'Legal middle name',
  lastName: 'Legal last name',
} as const;

export const PREFERRED_NAME_LABEL = 'Preferred name';

export const PREFERRED_NAME_HELP_BODY =
  'If provided, this name is used in place of the legal name everywhere this client is displayed in the app.';
